import NulogyCheckboxSelect from "components/common/CheckboxSelect";
import { useField, useFormikContext } from "formik";
import React, { useMemo } from "react";

export default function CheckboxSelect({ field: name, onChange, ...selectProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = useMemo(
    () => (value) => {
      if (onChange) {
        onChange({ setFieldValue, value });
      }
      helpers.setValue(value);
    },
    [onChange, helpers, setFieldValue],
  );

  return (
    <NulogyCheckboxSelect errorMessage={meta.error} onChange={handleChange} value={field.value} {...selectProps} />
  );
}
